import { cva } from "class-variance-authority";

/**
 * Shared CVA definitions for form components
 * These provide consistent styling across all form inputs, selects, and other form elements
 */

export const formWrapperCva = cva("relative font-roboto text-base");

export const formSubWrapperCva = cva("flex w-full", {
  variants: {
    layout: {
      "is-column": "flex-col",
      "is-row": "flex-row items-center",
    },
    loading: {
      true: "cursor-progress",
      false: null,
    },
    editable: {
      true: null,
      false: "cursor-default",
    },
    disabled: {
      true: "cursor-not-allowed",
      false: null,
    },
    labelCenter: {
      true: "items-center",
      false: null,
    },
    hasMargin: {
      true: "mb-[25px]",
      false: null,
    },
  },
  compoundVariants: [
    {
      layout: "is-row",
      labelCenter: true,
      class: "items-center",
    },
  ],
  defaultVariants: {
    layout: "is-column",
    loading: false,
    editable: true,
    disabled: false,
    labelCenter: false,
    hasMargin: false,
  },
});

export const formLabelCva = cva("leading-4 text-sm mb-[5px] text-(--text) gap-[5px]", {
  variants: {
    layout: {
      "is-row": "w-1/3",
      "is-column": null,
    },
    /**
     * `inline` for labels inside a component's own flex column; `block` for a label
     * placed directly in page markup, where an inline box would inherit the
     * surrounding line box's strut and sit a few pixels lower than its neighbours.
     */
    display: {
      inline: "inline-flex items-center",
      block: "flex items-center",
    },
    /** A label inside a formLabelRowCva row: the row owns the bottom margin. */
    flush: {
      true: "mb-0",
      false: null,
    },
  },
  defaultVariants: {
    layout: "is-column",
    display: "inline",
    flush: false,
  },
});

/** A label with its help question mark after it; carries the label's margin and row width. */
export const formLabelRowCva = cva("flex items-center gap-[5px] mb-[5px]", {
  variants: {
    layout: {
      "is-row": "w-1/3",
      "is-column": null,
    },
  },
  defaultVariants: {
    layout: "is-column",
  },
});

export const formRequiredCva = cva("text-(--secondary) font-bold");

export const formErrorMessageCva = cva("mt-1 text-sm text-danger-600");
